<template>
  <div class="vedioChat">
    <div v-if="videoChatState.display_messages" class="video-chat-messages">
      <call-messages />
    </div>
    <div class="videos__group">
      <div
        id="top_div"
        :style="$store.state.videoChat.screen_sharing ? 'height: 100%;' : ''"
      >
        <div
          class="video-grid"
          :class="!isVideo1Loaded ? 'video-grid-overlay' : ''"
          :style="
            $store.state.videoChat.screen_sharing
              ? '-moz-transform: scale(-1, 1); -webkit-transform: scale(-1, 1); -o-transform: scale(-1, 1); transform: scale(-1, 1); filter: FlipH;'
              : ''
          "
        >
          <div v-show="!isVideo1Loaded" class="video-loading1">
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <video
            v-show="isVideo1Loaded"
            ref="remoteVideoRef"
            playsinline
            webkit-playsinline
            poster="./videoChat_placeholder.png"
            :style="
              $store.state.videoChat.screen_sharing
                ? 'object-fit: contain;'
                : ''
            "
            @loadeddata="isVideo1Loaded = true"
          />
        </div>
      </div>
      <hr />
      <div
        id="bottom_div"
        :style="$store.state.videoChat.screen_sharing ? 'display: none;' : ''"
      >
        <div
          class="video-grid"
          :class="!isVideo2Loaded ? 'video-grid-overlay' : ''"
        >
          <div v-show="!isVideo2Loaded" class="video-loading2">
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <video
            v-show="isVideo2Loaded"
            ref="currentUserVideoRef"
            playsinline
            webkit-playsinline
            autoplay
            muted
            poster="./videoChat_placeholder.png"
            @loadeddata="isVideo2Loaded = true"
          />
        </div>
      </div>
    </div>
    <remote-media-state />
    <div class="call-footer">
      <div class="call-icons">
        <ul class="call-items">
          <li v-if="$store.state.videoChat.screen_sharing" class="call-item">
            <span
              id="resize-button"
              style="
                margin-top: calc(2.1em - 50%);
                position: absolute;
                display: flex;
                margin-left: calc(3em + 50%);
                background-color: rgba(255, 255, 255, 0.4);
                color: white;
              "
              @click="resize()"
            >
              <i class="material-icons"> aspect_ratio </i>
            </span>
          </li>
          <li class="call-item">
            <span @click="microphoneOnOff()">
              <i v-if="media.mic" class="material-icons"> mic </i>
              <i v-else class="material-icons"> mic_off </i>
            </span>
          </li>
          <li class="call-item">
            <span @click="cameraOnOff()">
              <i v-if="media.camera" class="material-icons"> videocam </i>
              <i v-else class="material-icons"> videocam_off </i>
            </span>
          </li>
          <li class="call-item">
            <span @click="chat_trigger()">
              <i class="material-icons"> chat </i>
              <span v-show="videoChatState.messageNotif" class="badge"></span>
            </span>
          </li>
          <li class="call-item">
            <span class="end-call" @click="end_call()">
              <i class="material-icons"> call_end </i>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CallMessages from "./CallMessages.vue";
import remoteMediaState from "./RemoteMediaState.vue";
//Raw CSS because styling in Iframe does not work
//So we add it dynamically
import videoChat from "!raw-loader!../../assets/VideoChatCss/videoChat.css";
import { customLogger } from "@/utils";

const videoRef = {
  current: null,
};

export default {
  name: "VideoCall",
  components: {
    CallMessages,
    remoteMediaState,
  },
  data: () => {
    return {
      isVideo1Loaded: false,
      isVideo2Loaded: false,
      media: {
        camera: true,
        mic: true,
      },
      resized: false,
    };
  },
  computed: {
    videoChatState() {
      const data = this.$store.state.videoChat;
      return data;
    },
  },
  destroyed() {
    this.$store.dispatch('CLOASE_STREAM')
    this.$store.state.videoChat = {
      display_video_chat: false,
      display_messages: false,
      GetCall: false,
      myPeer: undefined,
      remotePeerId: null,
      socketAddr: undefined,
      peercall: undefined,
      stream: undefined,
    };
  },
  async created() {
    this.appendStyle();
  },
  async mounted() {
    customLogger("mounted");
    videoRef.current = this.$refs.remoteVideoRef;

    await this.addVideoStream();
  },
  methods: {
    closeStream() {
      let stream = this.videoChatState.stream || window.stream
      stream.getTracks().forEach((track) => {
        customLogger("stop ", { track });
        track.stop();
      });
      stream = null;
      const peerCall = this.$store.state.videoChat.peercall;
        customLogger("destroyed", peerCall);
        if (peerCall) {
          peerCall.close();
        }
    },
    addVideoStream() {
      const remotePeerId = this.videoChatState.remotePeerId;
      const mediaStream = this.videoChatState.stream;

      this.$refs.currentUserVideoRef.muted = true;

      this.$refs.currentUserVideoRef.srcObject = mediaStream;
      this.$refs.currentUserVideoRef.addEventListener("loadedmetadata", () => {
        this.$refs.currentUserVideoRef.play();
      });

      const call = this.videoChatState.myPeer.call(remotePeerId, mediaStream);
      this.videoChatState.peercall = call;

      call.on("stream", (remoteStream) => {
        videoRef.current.srcObject = remoteStream;
        videoRef.current.addEventListener("loadedmetadata", () => {
          videoRef.current.play();
        });
      });
      call.on("close", () => {
        customLogger("in close steam");
        this.$store.dispatch('CLOASE_STREAM')
      });
    },
    appendStyle() {
      const iframe = document.getElementById("cleed-frame");
      const doc = iframe.contentWindow.document;

      let videoChat_style = doc.createElement("style");
      videoChat_style.innerHTML = videoChat;
      doc.body.appendChild(videoChat_style);
    },
    cameraOnOff() {
      customLogger("camera click");
      const stream = this.videoChatState.stream;
      const enabled = stream.getVideoTracks()[0].enabled;
      if (enabled) {
        stream.getVideoTracks()[0].enabled = false;
        this.media.camera = false;
      } else {
        stream.getVideoTracks()[0].enabled = true;
        this.media.camera = true;
      }
      this.videoChatState.socketAddr.emit("USER_MediaDevicesDtectChange", {
        video: this.media.camera,
        audio: this.media.mic,
        message: `User video ${this.video ? "enable" : "disable"}`,
      });
    },
    microphoneOnOff() {
      customLogger("mic click");
      const stream = this.videoChatState.stream;
      const enabled = stream.getAudioTracks()[0].enabled;
      customLogger(enabled);
      if (enabled) {
        stream.getAudioTracks()[0].enabled = false;
        this.media.mic = false;
      } else {
        stream.getAudioTracks()[0].enabled = true;
        this.media.mic = true;
      }
      this.videoChatState.socketAddr.emit("USER_MediaDevicesDtectChange", {
        video: this.media.camera,
        audio: this.media.mic,
        message: `User microphone ${this.video ? "enable" : "disable"}`,
      });
    },
    chat_trigger() {
      customLogger("chat click");
      this.videoChatState.display_messages = true;
    },
    end_call() {
      this.$store
        .dispatch("EndCall")
        .then(() => {
          customLogger("end the call");
          this.$store.dispatch('CLOASE_STREAM')
        })
        .catch((err) => {
          customLogger(err);
        });
    },
    resize() {
      this.resized = !this.resized;
      if (this.resized) {
        document.getElementById("box-frame").style.width = "1275px";
        document.getElementById("box-frame").style.height = "718.5px";
      } else {
        document.getElementById("box-frame").style.width = "850px";
        document.getElementById("box-frame").style.height = "479px";
      }
    },
  },
};
</script>
